import { IProfile } from '@/types'

import settings from '@/settings/public'

interface ICookieStore {
  getAll(): { name: string; value: string }[]
}

interface IFetchProfileOptions {
  /** Pass cookies when calling from server (e.g. layout) to forward session; omit for client fetches (browser sends cookies automatically) */
  cookies?: ICookieStore
  /** Server-only: client headers to forward on the loopback fetch (buildSsrForwardHeaders, PRO-946). */
  forwardHeaders?: Record<string, string>
}

export const fetchProfile = async (options?: IFetchProfileOptions): Promise<IProfile> => {
  const cookieHeader = options?.cookies
    ? options.cookies.getAll().map(c => `${c.name}=${c.value}`).join('; ')
    : undefined

  const reqHeaders: Record<string, string> = { ...options?.forwardHeaders, 'content-type': 'application/json' }
  if (cookieHeader) reqHeaders['Cookie'] = cookieHeader

  const profile = await fetch(`${settings.api.host}/api/1.0/auth/users/profile`, {
    method: 'GET',
    headers: reqHeaders,
    cache: 'no-store'
  })
  const response = await profile.json()

  if (response.error) {
    throw response.error
  }

  return response.data
}
